import matchList from '@gin-betting/match-list';

import {
    matchListRoutes,
    MATCHES_LIMIT_PER_PAGE,
    OUTRIGHTS_LIMIT_PER_PAGE,
    POLLING_EDGE_PAGE,
} from 'app-constants';
import { checkIfNewsPage } from 'utils';

const matchListReducer = matchList.reducer(
    MATCHES_LIMIT_PER_PAGE,
    matchListRoutes
);

export const paginationReducer = matchList.pagination.reducer({
    matchesLimitPerPage: checkIfNewsPage() ? 10 : MATCHES_LIMIT_PER_PAGE,
    outrightsLimitPerPage: OUTRIGHTS_LIMIT_PER_PAGE,
    pollingEdgePage: POLLING_EDGE_PAGE,
    routes: matchListRoutes,
});

export default matchListReducer;
